export default __webpack_public_path__ + "static/media/ic-edit-black.749bf214.svg";